import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  InputNumber,
  Tooltip,
} from "antd";
import { PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const FirmParameterUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [paymentSelect, setPaymentSelect] = useState({
    data: [],
    loading: false,
  });
  const [form] = Form.useForm();

  useEffect(() => {
    getPaymentSets();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getPaymentSets = () => {
    setPaymentSelect({ data: [], loading: true });

    RequestHandler.get(`/PaymentSet?$select=id,name`).then((res) => {
      setPaymentSelect({ data: res.value, loading: false });
    });
  };

  const onFinish = (values) => {
    RequestHandler.put(`/FirmParameter`, values)
      .then((response) => {
        setLoading(false);
        if (response?.success) {
          form.resetFields();
          if (props.onSuccess) props.onSuccess();
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const onFinishFailed = () => setLoading(false);

  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="firmParameterUpdate"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>

          <Form.Item name="firmName" label="Bayi Ünvanı">
            <Input disabled={true} />
          </Form.Item>

          <Form.Item name="paymentSetId" label="Ödeme Seti :">
            <Select
              allowClear
              showSearch
              placeholder="Varsayılan"
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={paymentSelect.loading}
            >
              {paymentSelect.data.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Row justify="space-between">
            <Col></Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default FirmParameterUpdateForm;
